import _ from 'lodash';

import { makeReactive } from '@dha/make-reactive';
import MetricChartModel from './MetricChartModel';
import BaseChartModel from './BaseChartModel';

const defaultOptions = {
    metricColumn: 'metric',
    titleColumn: 'label',
    keyColumn: 'cdiCategory',
    positiveDirection: 1,
    format: value => `${(value * 100).toFixed(0)}`,
    units: '%',
    domain: [0, 1],
    isPrimary: false
};

/* eslint-disable no-underscore-dangle */
export default class MultiValueMetricChartModel extends BaseChartModel {
    constructor(dataRecords, parent, options) {
        super(dataRecords, parent, { ...defaultOptions, ...options });
    }

    get submodels() {
        return _(this.rawDataRecords)
            .groupBy(this.options.keyColumn)
            .map((records, key) => {
                const submodel = makeReactive(new MetricChartModel(
                    records,
                    this.parent,
                    {
                        ...this.options,
                        titleColumn: this.options.keyColumn,
                        label: key,
                        id: _.kebabCase(`${this.id}${key}`)
                    }
                ));
                return submodel;
            })
            .value();
    }

    // eslint-disable-next-line class-methods-use-this
    get secondaryLabel() {
        // TODO: Actually implement this
        return '';
    }
}
